// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

interface CpnData {
    [key: string]: string;
}
export type PartNumbersState = Readonly<{
    data: CpnData;
}>;

const initialState: PartNumbersState = {
    data: {},
};

const reducer = {
    "xPartNumbers/ComplateLoadCpns": (draft: Draft<PartNumbersState>, action: { data: CpnData }) => {
        draft.data = { ...draft.data, ...action.data };
    },
};

const xPartNumbers = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xPartNumbers = xPartNumbers;

export type xPartNumbersState = {
    xPartNumbers: PartNumbersState;
} & ApplicationState;

type xPartNumbersReducers = {
    [key: string]: typeof xPartNumbers;
};

export type xPartNumbers = Parameters<xPartNumbersReducers[keyof xPartNumbersReducers]>[1] | AnyAction;
